import { NavbarBrand as _NavbarBrand, NavbarBrandProps as _NavbarBrandProps } from "reactstrap";

    export const NavbarBrand = _NavbarBrand;
    export type NavbarBrandProps = _NavbarBrandProps;
    